<script>
  import { SPRITESHEET_URL } from '../../utils/constants';

  let { skeletonLength = Math.floor(Math.random() * 3), noImage = false, phone = false } = $props();
</script>

<div
  class="w-full overflow-hidden block rounded-lg shadow-y-sm bg-gray-light-silver mx-auto"
  data-testid="available-location-skeleton-tile"
>
  {#if !noImage}
    <div class="w-full h-24 rounded-t-lg skeleton-gradient"></div>
  {/if}
  <div class="min-h-24 flex justify-between">
    <div class="flex flex-col w-full bg-white">
      <div class="flex justify-between w-full">
        <div class="bg-white p-4 pr-10 pb-5 flex justify-between items-center rounded-bl-lg overflow-hidden">
          <div class="flex flex-col justify-between max-w-36">
            <div
              class="h-5 skeleton-gradient animated-skeleton mb-2"
              class:w-48={skeletonLength === 0}
              class:w-53={skeletonLength === 1}
              class:w-36={skeletonLength === 2}
            ></div>
            <div
              class="h-4 skeleton-gradient animated-skeleton mb-1 animation-delay-75"
              class:w-36={skeletonLength === 0}
              class:w-30={skeletonLength === 1}
              class:w-40={skeletonLength === 2}
            ></div>
            <div
              class="h-4 skeleton-gradient animated-skeleton animation-delay-150"
              class:w-36={skeletonLength === 0}
              class:w-40={skeletonLength === 1}
              class:w-32={skeletonLength === 2}
            ></div>
          </div>
        </div>
        <div class="bg-white flex grow-0 shrink-0 justify-end p-4" class:items-center={!phone}>
          <div class="h-4 skeleton-gradient animated-skeleton w-10"></div>
        </div>
      </div>
      {#if phone}
        <div class="border-t border-gray-pale mx-4 py-2.5">
          <div class="h-4 w-36 skeleton-gradient animated-skeleton"></div>
        </div>
      {/if}
    </div>
    <div class="flex flex-none items-center justify-center w-6 bg-gray-pale">
      <svg class="h-4 w-4 fill-current text-gray-silver" role="presentation">
        <use xlink:href="{SPRITESHEET_URL}#chevron-right" />
      </svg>
    </div>
  </div>
</div>
